import React, { useEffect, useState } from 'react';
import { Table, SearchInput } from 'components';
import { FormDetail } from './form-detail';
import { Box } from '@mui/material';
import { BsPlus } from 'react-icons/bs';
import ApiServices from 'services';
import { Columns } from './columns';
import { ContainerHeader, ButtonAdd } from './styles';

function CargoTypePage() {
  const [cargoTypeList, setCargoTypeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const initData = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getCargoTypes();
      setCargoTypeList(data || []);
    } catch (err) {
      console.warn('initData - Cargo type', err);
    }
    setLoading(false);
  };
  useEffect(() => {
    initData();
  }, []);

  const deleteCargoTypeItem = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deleteCargoType(row.id);

      if (res) {
        window.UIMessage?.success('Xóa thành công');
        initData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('deleteCargoTypeItem - Cargo type', err);
    }
    setLoading(false);
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <SearchInput sx={{ mr: 2 }} maxWidth={400} />
      </ContainerHeader>
      <ButtonAdd
        variant="contained"
        size="small"
        startIcon={<BsPlus />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </ButtonAdd>
    </>
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          rows={cargoTypeList}
          headCells={Columns(deleteCargoTypeItem)}
          onClickDetail={(row) => {
            setSelected(row);
          }}
          title="Loại hàng hóa"
          loading={loading}
          renderHeader={renderHeader}
        />
        <FormDetail {...{ selected, setSelected, initData }} />
      </Box>
    </>
  );
}
export { CargoTypePage };
